"use strict";

const AssetRoutineMaintenanceGeneralInfo = function (Controller) {
  const stringKey = "general-info";
  let $page;

  var loadListeners = function (data) {
    $page = $(`#assessment-modal #${stringKey}`);
    $page.on("2N:FormInput", "[name='date']", showDateWarning);
    RoutineMaintenanceFormGeneral.loadListenersWqMonitoringWorkflow($page, data, Controller);
  };

  var unloadListeners = function () {
    $page.off("2N:FormInput", "[name='date']", showDateWarning);
    RoutineMaintenanceFormGeneral.unloadListeners($page);
  };

  var showDateWarning = function (e, value) {
    if (!value) {
      MessageModal.showSimpleWarningModal(`Please enter a valid date.`);
      const defaultDate = DateTime.getTodayIso();
      Form.manuallySetDateTime(Controller.formKey, ["date"], defaultDate, $(e.currentTarget));
    }
  };

  var getProps = function (data) {
    return {
      wqInspectionTypeOptions: getInspectionTypeOptions(data),
      flowConditionOptions: WqMonitoringConstants.getFlowConditionOptions(),
      currentWeatherOptions: WqMonitoringConstants.getCurrentWeatherOptions(),
    };
  };

  var getInspectionTypeOptions = function (data) {
    const allowedTypes = AssetTypeConfig.get(data.assetInfo.assetType).inspectionTypeOptions;

    return WqMonitoringConstants.getWqInspectionTypeOptions().filter((option) =>
      allowedTypes.includes(option.value),
    );
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return RoutineMaintenanceFormGeneral.getTabName();
  };

  var getPage = function () {
    return $page;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
    getPage,
  };
};

module.exports = AssetRoutineMaintenanceGeneralInfo;

const AssetTypeConfig = require("./assetTypeConfig");
const DateTime = require("../../dateTime");
const Form = require("../../general/form");
const MessageModal = require("../../modals/messageModal");
const RoutineMaintenanceFormGeneral = require("../../general/routineMaintenanceFormGeneral");
const WqMonitoringConstants = require("../../wq/inspection/wqMonitoringConstants");
